<template>
<div v-loading="pLoading" class="equipmentLibrary">
  <el-card class="box-card" shadow="never">
    <div class="wrap-page" @click="getMouseXY($event)">
      <el-form ref="form" :inline="true" :model="form">
        <el-form-item label="层级类型:">
          <el-select v-model="form.topProductTypeId" placeholder="请选择" clearable @change="searchProductList(1)">
            <el-option v-for="item in levelTypeList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品类型:">
          <el-select v-model="form.productType" placeholder="请选择" clearable>
            <el-option v-for="item in productTypeList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="searchIcon" icon="el-icon-search" @click="onSearch()"></el-button>
        </el-form-item>
        <el-form-item label="关键字:" style="float: right;">
          <template>
            <span class="keywordClass">
              <el-select class="filterType" v-model="filterType" popper-class="filterTypePopper" placeholder="请选择" style="width: 100px;">
                <el-option label="全部" value="0"></el-option>
                <el-option label="设备" value="1"></el-option>
                <el-option label="点" value="2"></el-option>
              </el-select>
              <el-select class="searchKeyClass" v-model="form.searchKey" clearable filterable remote reserve-keyword placeholder="请输入关键词" :remote-method="remoteMethod" :loading="loading" style="width: 450px;">
                <el-option v-html="item.label" v-for="item in options" :key="item.id" :label="item.value" :value="item.id">
                </el-option>
                <el-button :disabled="options.length == pageTotal" class="moreBtn" type="text" size="small" @click="searchMore()">更多......</el-button>
              </el-select>
            </span>
          </template>
        </el-form-item>
      </el-form>
      <div class="leftTree">
        <el-button type="primary" size="small" @click="addTreeDate()" style="margin-bottom: 15px;">新增</el-button>
        <el-button type="primary" size="small" @click="leadingIn()" style="margin-left: 10px;margin-bottom: 15px;">导入</el-button>
        <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        <el-tree class="filter-tree" :data="treeData" :props="defaultProps" node-key="id" highlight-current :expand-on-click-node="false" :filter-node-method="filterNode" ref="tree" @node-click="handleNodeClick">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span v-if="node.label.length<20">{{ node.label }}</span>
            <el-tooltip v-else effect="light" :content="node.label" :open-delay="500" placement="top">
              <span>{{ node.label }}</span>
            </el-tooltip>
            <!-- <el-button v-show="!data.show" class="btn" type="text" size="mini" @click="handle(data)">操作</el-button>
              <el-button v-show="data.show" class="btn" type="text" size="mini" @click="complete(data)" style="color: #67C23A;font-weight: bold;margin-left: 20px !important;">完成</el-button> -->
            <!-- <img v-show="data.show" src="../../../../static/images/boss/complete.png" alt="" @click="complete(data)" style="width: 12px;"> -->
            <span>
              <el-tooltip content="新增" :disabled="disabled" :open-delay="500" placement="top" effect="light">
                <img src="../../../../static/images/boss/append.png" alt="" @click="() => append(data)" style="width: 12px;">
              </el-tooltip>
              <el-tooltip content="添加数据点" :disabled="disabled" :open-delay="500" placement="top" effect="light">
                <img src="../../../../static/images/boss/addDataPoint.png" alt="" @click="() => addDataPoint()" style="width: 12px;">
              </el-tooltip>
              <span id="sector">
                <span class="moreIcon">
                  <!-- <el-tooltip content="更多" :open-delay="500" placement="top" effect="light"> -->
                  <img src="../../../../static/images/boss/more.png" alt="" @click.stop="() => more(data)" style="width: 12px;">
                  <!-- </el-tooltip> -->
                </span>
                <ul v-show="data.show">
                  <el-tooltip content="新增" :open-delay="500" placement="top" effect="light">
                    <li class="sector1" @click="() => append(data)">
                      <img src="../../../../static/images/boss/append.png" alt="" style="width: 12px;">
                    </li>
                  </el-tooltip>
                  <el-tooltip content="添加数据点" :open-delay="500" placement="top" effect="light">
                    <li class="sector2" @click="() => addDataPoint()">
                      <img src="../../../../static/images/boss/addDataPoint.png" alt="" style="width: 12px;">
                    </li>
                  </el-tooltip>
                  <el-tooltip content="编辑" :open-delay="500" placement="top" effect="light">
                    <li class="sector3" @click="() => edit()">
                      <img src="../../../../static/images/boss/edit.png" alt="" style="width: 12px;">
                    </li>
                  </el-tooltip>
                  <el-tooltip content="选择" :open-delay="500" placement="top" effect="light">
                    <li class="sector4" @click="choose(data)">
                      <img src="../../../../static/images/boss/choose.png" alt="" style="width: 12px;">
                    </li>
                  </el-tooltip>
                  <el-tooltip content="复制" :open-delay="500" placement="top" effect="light">
                    <li class="sector5" @click="() => copy(data)">
                      <img src="../../../../static/images/boss/copy.png" alt="" style="width: 12px;">
                    </li>
                  </el-tooltip>
                  <el-tooltip content="导入" :open-delay="500" placement="top" effect="light">
                    <li class="sector6">
                      <img src="../../../../static/images/boss/import.png" alt="" style="width: 12px;">
                    </li>
                  </el-tooltip>
                  <el-tooltip content="删除" :open-delay="500" placement="top" effect="light">
                    <li class="sector7" @click="() => remove(node, data)">
                      <img src="../../../../static/images/boss/delete.png" alt="" style="width: 12px;">
                    </li>
                  </el-tooltip>
                </ul>
              </span>
            </span>
            <div v-if="data.isCopyBlock" class="copyBlock">
              <el-input v-model="copyDeviceCode" placeholder="名称" size="mini" style="width: 160px;"></el-input>
              <el-button type="primary" size="mini" style="margin-left: 5px;" @click="copyDeviceLibrary()">确定</el-button>
            </div>

            <!-- <el-button class="btn" type="text" size="mini" @click="() => append(data)">
              +
            </el-button>
            <el-button class="btn" type="text" size="mini" @click="() => choose(data)">
              选择
            </el-button>
            <el-button class="btn" type="text" size="mini" @click="() => remove()">
              -
            </el-button>
            <el-button class="btn" type="text" size="mini" @click="edit()">
              修改
            </el-button>
            <el-popover placement="top">
              <div style="display: flex;">
                <el-input v-model="copyDeviceCode" placeholder="名称" style="width: 200px;"></el-input>
                <el-button type="primary" size="mini" style="margin-left: 10px;" @click="copyDeviceLibrary()">确定</el-button>
              </div>
              <el-button class="btn" slot="reference" type="text" size="mini" @click="() => copy(data)">
                复制
              </el-button>
            </el-popover>
            <el-button class="btn" type="text" size="mini" @click="() => leadingIn(node, data)">
              导入
            </el-button>
            <el-button class="btn" type="text" size="mini" @click="() => addDataPoint()">
              添加数据点
            </el-button> -->
          </span>
        </el-tree>
      </div>
      <el-button v-if="dataPointIds.length>0" class="batchBtn" type="danger" size="small" @click="batchDelete()">批量删除</el-button>
      <div class="rightTable">
        <el-table ref="dataPointTable" :data="tableData" border highlight-current-row height="66vh" @selection-change="handleDataPointSelectionChange" style="width: 100%;">
          <el-table-column type="selection" width="50">
          </el-table-column>
          <el-table-column prop="fieldName" label="名称" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span v-html="row.fieldName"></span>
            </template>
          </el-table-column>
          <el-table-column prop="fieldCode" label="标识" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span v-html="row.fieldCode"></span>
            </template>
          </el-table-column>
          <el-table-column prop="dataTypeId" label="类型" width="100">
            <template slot-scope="{ row }">
              <span v-html="row.dataTypeId"></span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="defaultValue" label="默认值" width="80" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span v-html="row.defaultValue"></span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="coefficient" label="系数" width="80" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span v-html="row.coefficient"></span>
            </template>
          </el-table-column> -->
          <el-table-column prop="authorization" label="权限" width="70">
            <template slot-scope="{ row }">
              {{ row.authorization == 0 ? "只读" : row.authorization == 1 ? "只写" : "读写" }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="170">
            <template slot-scope="{ row }">
              <span v-html="row.createTime"></span>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="修改时间" width="170">
            <template slot-scope="{ row }">
              <span v-html="row.updateTime"></span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="fieldDescribe" label="描述" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span v-html="row.fieldDescribe"></span>
            </template>
          </el-table-column> -->
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="{ row }">
              <el-button class="btn" type="text" size="small" @click="onEdit(row)">修改</el-button>
              <el-button class="btn" type="text" size="small" @click="onDelete(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-card>
  <!-- 层级配置 -->
  <Dialog ref="levelConfigDialog" title="层级配置" :before-close="handleClose">
    <el-form ref="levelConfigForm" :rules="levelConfigRules" :model="levelConfigForm" label-width="100px">
      <el-form-item label="名称:" prop="deviceName" required>
        <el-input v-model="levelConfigForm.deviceName" placeholder="名称" style="width: 80%;"></el-input>
      </el-form-item>
      <el-form-item label="标识:" prop="deviceCode" required>
        <el-input v-model="levelConfigForm.deviceCode" placeholder="标识" style="width: 80%;"></el-input>
      </el-form-item>
      <el-form-item label="类型:" prop="topProductTypeId" required>
        <el-select v-model="levelConfigForm.topProductTypeId" clearable placeholder="类型" style="width: 60%;" @change="searchProductList(2)">
          <el-option v-for="(item, index) in levelTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="productTypeList.length>0" label="产品类型:" prop="productId">
        <el-select v-model="levelConfigForm.productId" clearable placeholder="产品类型" @change="pickChange" style="width: 60%;">
          <el-option v-for="(item, index) in productTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="厂商:" prop="manufacturersId">
        <el-select v-model="levelConfigForm.manufacturersId" clearable placeholder="厂商" style="width: 60%;">
          <el-option v-for="(item, index) in manufacturersList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="是否有电芯:">
        <el-switch v-model="levelConfigForm.isExistsBattery" active-color="#13ce66" inactive-color="#ff4949">
        </el-switch>
      </el-form-item>
      <el-form-item v-if="isZeroFilling" label="是否补零:">
        <el-switch v-model="levelConfigForm.isRepairZero" active-color="#13ce66" inactive-color="#ff4949">
        </el-switch>
      </el-form-item> -->
      <el-form-item>
        <el-button :loading="btnLoading" type="primary" @click="saveLevelConfig('levelConfigForm')" style="margin-left: 36%;transform: translateX(-50%);">保存</el-button>
      </el-form-item>
    </el-form>
  </Dialog>
  <!-- 层级选择 -->
  <Dialog ref="chooseDataDialog" title="层级选择" dlgWidth="60%">
    <el-form ref="chooseDataForm" :inline="true" :model="chooseDialogData">
      <el-form-item label="层级类型:">
        <el-select v-model="chooseDialogData.topProductTypeId" clearable placeholder="层级类型" @change="searchProductList(3)">
          <el-option v-for="(item, index) in levelTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品类型:">
        <el-select v-model="chooseDialogData.productType" clearable placeholder="产品类型" @change="pickChange">
          <el-option v-for="(item, index) in productTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关键字:">
        <el-input v-model="chooseDialogData.searchKey" clearable style="width: 200px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onChooseSearch()">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="multipleTable" :data="levelTableData" height="300" @selection-change="handleSelectionChange" @select="handleSelectionRows" style="width: 100%;">
      <el-table-column type="selection" width="50">
      </el-table-column>
      <el-table-column type="index" label="序号" width="60">
      </el-table-column>
      <el-table-column prop="topProductTypeName" label="层级类型">
        <template slot-scope="{ row }">
          <span v-html="row.topProductTypeName"></span>
        </template>
      </el-table-column>
      <el-table-column prop="productTypeName" label="产品类型">
        <template slot-scope="{ row }">
          <span v-html="row.productTypeName"></span>
        </template>
      </el-table-column>
      <el-table-column prop="deviceName" label="名称">
        <template slot-scope="{ row }">
          <span v-html="row.deviceName"></span>
        </template>
      </el-table-column>
      <el-table-column prop="deviceCode" label="标识">
        <template slot-scope="{ row }">
          <span v-html="row.deviceCode"></span>
        </template>
      </el-table-column>
      <el-table-column prop="parentName" label="上级设备名称">
        <template slot-scope="{ row }">
          <span v-html="row.parentName"></span>
        </template>
      </el-table-column>
      <el-table-column prop="parentDeviceCode" label="上级设备标识">
        <template slot-scope="{ row }">
          <span v-html="row.parentDeviceCode"></span>
        </template>
      </el-table-column>
    </el-table>
    <el-button type="primary" @click="saveEquipmentLibraryChoose()" style="margin-top: 20px;margin-left: 50%;transform: translateX(-50%);">确定</el-button>
  </Dialog>
  <!-- 数据点配置 -->
  <Dialog ref="dataPointConfigDialog" title="数据点配置">
    <el-form ref="dataPointConfigForm" :rules="dataPointConfigRuleForm" :model="dataPointConfigForm" label-width="100px">
      <el-form-item label="名称:" prop="fieldName" required>
        <el-input v-model="dataPointConfigForm.fieldName" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item>
      <el-form-item label="数据点类型:" prop="dataTypeId">
        <el-select v-model="dataPointConfigForm.dataTypeId" clearable filterable placeholder="产品类型">
          <el-option v-for="(item, index) in dataTypeIdList" :key="index" :label="item.name + '(' + item.code + ')'" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标识:" prop="fieldCode" required>
        <el-input v-model="dataPointConfigForm.fieldCode" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item>
      <!-- <el-form-item label="默认值:" prop="defaultValue">
        <el-input v-model="dataPointConfigForm.defaultValue" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="点描述:" prop="fieldDescribe">
        <el-input v-model="dataPointConfigForm.fieldDescribe" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="系数:" prop="coefficient">
        <el-input v-model="dataPointConfigForm.coefficient" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item> -->
      <el-form-item label="权限:" prop="authorization" required>
        <el-select v-model="dataPointConfigForm.authorization" clearable placeholder="权限">
          <el-option v-for="(item, index) in authorityList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="数据类别:" prop="dataType" required>
        <el-select v-model="dataPointConfigForm.dataType" clearable placeholder="数据类别">
          <el-option v-for="(item, index) in dataTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="数据类型:" prop="type">
        <el-select v-model="dataPointConfigForm.type" clearable placeholder="数据类型">
          <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="数值类型:" prop="valueType" required>
        <el-select v-model="dataPointConfigForm.valueType" clearable placeholder="数值类型">
          <el-option v-for="(item, index) in valueTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="数值范围:" prop="range">
        <el-input v-model="dataPointConfigForm.range" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item> -->
      <el-form-item label="数据点单位:" prop="unit">
        <el-input v-model="dataPointConfigForm.unit" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item>
      <el-form-item v-if="!isTableEdit" label="个数:" prop="count">
        <el-input v-model="dataPointConfigForm.count" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item>
      <el-form-item v-if="!isTableEdit" label="是否补零:" prop="isFixZero">
        <el-switch class="elSwitch" v-model="dataPointConfigForm.isFixZero" active-text="是" inactive-text="否"></el-switch>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="confirmDataPointConfigData('dataPointConfigForm')" style="margin-top: 20px;margin-left: 50%;transform: translateX(-50%);">确定</el-button>
  </Dialog>
  <!-- 导入 -->
  <Dialog ref="leadingInDialog" title="导入">
    <el-form ref="leadingInForm" :model="leadingInForm" label-width="80px">
      <el-form-item label="厂商:" prop="manufacturerId">
        <el-select v-model="leadingInForm.manufacturerId" clearable placeholder="厂商" style="width: 60%;">
          <el-option v-for="(item, index) in manufacturersList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-upload class="upload-demo" ref="upload" action="" :before-upload="beforeUpload" accept=".xls, .xlsx" multiple :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :http-request="handleUpload" :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xlsx/xls文件！</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="submitLeadingForm()" style="margin-top: 20px;margin-left: 50%;transform: translateX(-50%);">提交</el-button>
  </Dialog>
</div>
</template>

<script>
import Dialog from '@/components/dialog';
import EquipmentLibraryApi from '@/api/equipmentLibrary';
import VENDORAPI from '@/api/vendorManagement';
export default {
  props: {
    value: {
      type: String,
      require: true
    },
  },
  data() {
    return {
      pLoading: false,
      form: {
        topProductTypeId: null,
        productType: null,
        searchKey: ''
      },
      loading: false,
      start: 0,
      end: 10,
      pageTotal: 10,
      levelTypeList: [],
      productTypeList: [],
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'childList',
        label(data) {
          return data.deviceCode + " (" + data.deviceName + ")"
        }
      },
      tableData: [],
      levelConfigForm: {
        deviceName: '',
        deviceCode: '',
        manufacturersId: '',
        topProductTypeId: '',
        productId: '',
        // isExistsBattery: true,
        // isRepairZero: true
      },
      levelConfigRules: {
        deviceName: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        deviceCode: [{
          required: true,
          message: '请输入标识',
          trigger: 'blur'
        }],
        topProductTypeId: [{
          required: true,
          message: '请选择类型',
          trigger: 'change'
        }]
      },
      manufacturersList: [],
      chooseDialogData: {
        topProductTypeId: '',
        productType: '',
        searchKey: ''
      },
      levelTableData: [],
      dataPointConfigForm: {
        fieldName: '',
        dataTypeId: '',
        fieldCode: '',
        // defaultValue: '',
        // fieldDescribe: '',
        // coefficient: '',
        authorization: '',
        dataType: '',
        // type: '',
        valueType: '',
        // range: '',
        unit: '',
        count: '',
        isFixZero: false // 是否补0，1是补0，0是不补0
      },
      dataPointConfigRuleForm: {
        fieldName: [{
          required: true,
          message: '请输入数据点名称',
          trigger: 'blur'
        }],
        fieldCode: [{
          required: true,
          message: '请输入数据点标识',
          trigger: 'blur'
        }],
        dataType: [{
          required: true,
          message: '请选择数据类型',
          trigger: 'change'
        }],
        valueType: [{
          required: true,
          message: '请选择数值类型',
          trigger: 'change'
        }],
        authorization: [{
          required: true,
          message: '请选择权限',
          trigger: 'change'
        }],
        unit: [{
          required: true,
          message: '请输入权限',
          trigger: 'blur'
        }],
      },
      dataTypeIdList: [],
      authorityList: [{
        id: 0,
        name: '只读'
      }, {
        id: 1,
        name: '只写'
      }, {
        id: 2,
        name: '读写'
      }],
      dataTypeList: [{
        id: 0,
        name: '未知'
      }, {
        id: 1,
        name: '遥测'
      }, {
        id: 2,
        name: '遥信'
      }, {
        id: 3,
        name: '遥调'
      }, {
        id: 4,
        name: '遥控'
      }],
      typeList: [{
        id: 1,
        name: '模拟量'
      }, {
        id: 2,
        name: '数字量'
      }, {
        id: 3,
        name: '信号量'
      }],
      valueTypeList: [{
        id: 1,
        name: 'int'
      }, {
        id: 2,
        name: 'float'
      }, {
        id: 3,
        name: 'string'
      }],
      fileList: [],
      isZeroFilling: true,
      currTreeData: {},
      isTableEdit: false,
      isHandle: false,
      isTreeEdit: false,
      filterType: '0',
      options: [],
      keyWord: '',
      searchType: '0',
      copyData: {
        topProductTypeId: null,
        productType: null,
        searchKey: ''
      },
      copyFilterType: '0',
      scrollStart: 0,
      scrollEnd: 10,
      scrollTotal: 0,
      isAddParentTree: true,
      currFieldId: '',
      bindDeviceLibraryIds: [],
      chooseTreeId: '',
      copyTreeData: {},
      copyDeviceCode: '',
      disabled: false,
      btnLoading: false,
      leadingInForm: {
        manufacturerId: ''
      },
      files: [],
      dataPointIds: [],
      selectionRows: []
    };
  },
  components: {
    Dialog
  },
  created() {
    this.searchProductList(0);
    this.onSearch();
    this.searchManufacturerList();
  },
  mounted() {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    // 'levelConfigForm.isExistsBattery'(val) {
    //   if (!val) {
    //     this.isZeroFilling = false;
    //   } else {
    //     this.isZeroFilling = true;
    //   }
    // },
    'form.searchKey'(val) {
      this.options = [];
      this.setName(this.treeData);
      // this.$emit('input', val)
    },
    levelTableData(val) {
      this.$nextTick(() => {
        if (this.selectionRows) {
          this.selectionRows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          })
        }
      })
    }
  },
  methods: {
    //层级类型列表
    searchDataFieldTypes() {
      EquipmentLibraryApi.searchDataFieldTypes().then(res => {
        if (res.data.code == 200) {
          this.dataTypeIdList = res.data.data;
        }
      });
    },
    //产品类型列表
    searchProductList(data) {
      this.form.productType = "";
      // this.levelConfigForm.productId = "";
      this.chooseDialogData.productType = "";
      let flag = false;
      let params = {
        parentId: null
      };
      if (data == 0) {
        flag = true;
        params.parentId = 0;
      } else if (data == 1) {
        if (this.form.topProductTypeId != "") {
          flag = true;
          params.parentId = this.form.topProductTypeId;
        }
      } else if (data == 2) {
        if (this.levelConfigForm.topProductTypeId != "") {
          flag = true;
          params.parentId = this.levelConfigForm.topProductTypeId;
        }
      } else if (data == 3) {
        if (this.chooseDialogData.topProductTypeId != "") {
          flag = true;
          params.parentId = this.chooseDialogData.topProductTypeId;
        }
      }
      if (flag) {
        EquipmentLibraryApi.searchProductList(params).then(res => {
          if (res.data.code == 200) {
            if (data == 0) {
              this.levelTypeList = res.data.data;
            } else {
              this.productTypeList = res.data.data;
            }
          }
        });
      }
    },
    pickChange() {
      this.$forceUpdate();
    },
    remoteMethod(query) {
      this.keyWord = query;
      this.start = 0;
      this.end = 10;
      this.loading = true;
      if (query != "") {
        try {
          let params = {
            start: this.start,
            productTypeId: this.form.productType,
            searchKey: query,
            end: this.end,
            topProductTypeId: this.form.topProductTypeId,
            type: this.filterType
          };
          EquipmentLibraryApi.searchDeviceLibrary(params).then(res => {
            if (res.data.code == 200) {
              var result = res.data.data.dataList;
              if (result.length > 0) {
                for (let i in result) {
                  result[i].label = "上级设备：" + result[i].parentDeviceCode + "(" + result[i].parentName + ")，设备：" + result[i].deviceCode + "(" + result[i].deviceName + ")，点：" + result[i].fieldCode + "(" + result[i].fieldName + ")";
                  var el = document.createElement('div');
                  el.innerHTML = result[i].label;
                  el.getElementsByTagName('a'); // Live NodeList of your anchor elements
                  result[i].value = el.innerText;
                  result[i].id = result[i].deviceId + "_" + result[i].fieldId;
                }
                this.options = result;
              }
              this.pageTotal = res.data.data.totalCount != 0 ? res.data.data.totalCount : 10;
            }
          });
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false;
        }
      }
    },
    searchMore() {
      this.start += 10;
      this.end += 10;
      this.loading = true;
      try {
        let params = {
          start: this.start,
          productTypeId: this.form.productType,
          searchKey: this.keyWord,
          end: this.end,
          topProductTypeId: this.form.topProductTypeId,
          type: this.filterType
        };
        EquipmentLibraryApi.searchDeviceLibrary(params).then(res => {
          if (res.data.code == 200) {
            var result = res.data.data.dataList;
            if (result.length > 0) {
              for (let i in result) {
                result[i].label = "上级设备：" + result[i].parentDeviceCode + "(" + result[i].parentName + ")，设备：" + result[i].deviceCode + "(" + result[i].deviceName + ")，点：" + result[i].fieldCode + "(" + result[i].fieldName + ")";
                var ele = document.createElement('div');
                ele.innerHTML = result[i].label;
                ele.getElementsByTagName('a'); // Live NodeList of your anchor elements
                result[i].value = ele.innerText;
                result[i].id = result[i].deviceId + "_" + result[i].fieldId;
              }
              this.options = this.options.concat(result);
            } else {
              this.$message.warning("已无更多数据！");
            }
          }
        });
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false;
      }
    },
    searchDeviceLibrary() {
      let params = {
        start: this.scrollStart,
        productTypeId: this.chooseDialogData.productType,
        searchKey: this.chooseDialogData.searchKey,
        end: this.scrollEnd,
        topProductTypeId: this.chooseDialogData.topProductTypeId,
        type: 0
      };
      EquipmentLibraryApi.searchDeviceLibrary(params).then(res => {
        if (res.data.code == 200) {
          this.levelTableData = this.levelTableData.concat(res.data.data.dataList);
        }
      });
    },
    onSearch() {
      let params = {
        productTypeId: this.form.productType,
        topProductTypeId: this.form.topProductTypeId,
        searchKey: this.form.searchKey
      }
      EquipmentLibraryApi.searchDeviceLibraryTree(params).then(res => {
        if (res.data.code == 200) {
          this.treeData = res.data.data;
        }
      });
      this.isHandle = false;
    },
    setName(datas) { //遍历树  获取id数组
      let deviceId = this.form.searchKey.split("_")[0];
      this.currFieldId = this.form.searchKey.split("_")[1];
      for (var i in datas) {
        if (datas[i].id == deviceId) {
          this.$refs.tree.setCurrentKey(datas[i].id);
          let params = {
            id: datas[i].id
          };
          this.searchFieldByDevice(params);
        }
        if (datas[i].childList) { //存在子节点就递归
          this.setName(datas[i].childList);
        }
      }
    },
    addTreeDate() {
      this.isTreeEdit = false;
      this.isAddParentTree = true;
      this.levelConfigForm = {};
      this.$refs.levelConfigDialog.open();
    },
    handleClose() {
      this.btnLoading = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.deviceCode.indexOf(value) !== -1 || data.deviceName.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      this.pLoading = true;
      if (data.show) {
        this.$set(data, 'show', false);
      }
      this.currTreeData = data;
      if (!this.isHandle) {
        let params = {
          deviceId: data.id
        }
        EquipmentLibraryApi.searchFieldByDevice(params).then(res => {
          if (res.data.code == 200) {
            this.tableData = res.data.data;
            for (let i in this.tableData) {
              for (let j in this.dataTypeIdList) {
                if (this.tableData[i].dataTypeId == this.dataTypeIdList[j].id) {
                  this.tableData[i].dataTypeId = this.dataTypeIdList[j].name;
                }
              }
            }
          }
          this.pLoading = false;
        });
      } else {
        this.pLoading = false;
      }
    },
    searchFieldByDevice(data) {
      let params = {
        deviceId: data.id
      }
      EquipmentLibraryApi.searchFieldByDevice(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data;
          for (let i in this.tableData) {
            if (this.tableData[i].id == this.currFieldId) {
              this.$refs.dataPointTable.setCurrentRow(this.tableData[i]);
            }
            for (let j in this.dataTypeIdList) {
              if (this.tableData[i].dataTypeId == this.dataTypeIdList[j].id) {
                this.tableData[i].dataTypeId = this.dataTypeIdList[j].name;
              }
            }
          }
        }
      });
    },
    handleDataPointSelectionChange(val) {
      this.dataPointIds = val;
    },
    batchDelete() {
      let self = this;
      this.$confirm('确定要删除这些吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          let deviceFieldIds = [];
          for (let i in self.dataPointIds) {
            deviceFieldIds.push(self.dataPointIds[i].id);
          }
          self.batchDeleteDeviceDataField(deviceFieldIds);
        })
        .catch(() => {});
    },
    batchDeleteDeviceDataField(id) {
      let params = {
        deviceFieldIds: id.join(",")
      };
      EquipmentLibraryApi.batchDeleteDeviceDataField(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("删除成功！");
          this.searchFieldByDevice(this.currTreeData);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg
          });
        }
      });
    },
    handle(data) {
      this.isHandle = true;
      this.currTreeData = data;
      this.$set(data, 'show', true);
    },
    complete(data) {
      this.isHandle = false;
      this.$set(data, 'show', false)
    },
    append(data) {
      this.isTreeEdit = false;
      this.isAddParentTree = false;
      this.levelConfigForm = {};
      this.$refs.levelConfigDialog.open();
    },
    searchManufacturerList() {
      VENDORAPI.searchManufacturerList().then(res => {
        if (res.data.code == 200) {
          this.manufacturersList = res.data.data;
        }
      });
    },
    saveLevelConfig(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          this.levelConfigForm.parentId = !this.isAddParentTree ? this.currTreeData.id : 0;
          let params = this.levelConfigForm;
          // if (this.levelConfigForm.isExistsBattery) {
          //   params.isExistsBattery = 1;
          // } else {
          //   params.isExistsBattery = 0;
          // }
          // if (this.levelConfigForm.isRepairZero) {
          //   params.isRepairZero = 1;
          // } else {
          //   params.isRepairZero = 0;
          // }
          if (params.topProductTypeId != 3) {
            params.productId = params.topProductTypeId;
          }
          if (!this.isTreeEdit) {
            EquipmentLibraryApi.addDeviceLibrary(params).then(res => {
              this.btnLoading = false;
              if (res.data.code == 200) {
                this.$refs.levelConfigDialog.close();
                this.$message.success("添加成功！");
                this.onSearch();
              }
            }).catch(e => {
              this.btnLoading = false;
              console.log(e);
            });
          } else {
            params.parentId = this.currTreeData.parentId;
            EquipmentLibraryApi.updateDeviceLibrary(params).then(res => {
              this.btnLoading = false;
              if (res.data.code == 200) {
                this.$refs.levelConfigDialog.close();
                this.$message.success("修改成功！");
                this.onSearch();
              }
            }).catch(e => {
              this.btnLoading = false;
              console.log(e);
            });
          }
        } else {
          return false;
        }
      })
    },
    more(data) {
      if (this.moreData && data.id != this.moreData.id) {
        this.$set(this.moreData, 'show', false);
      }
      this.moreData = data;
      this.currTreeData = data;
      this.disabled = !this.disabled;
      this.$set(data, 'show', !data.show);
    },
    getMouseXY(e) {
      if (this.moreData) {
        this.$set(this.moreData, 'show', false);
        this.$set(this.moreData, 'isCopyBlock', false);
      }
    },
    choose(data) {
      this.chooseTreeId = data.id;
      this.$refs.chooseDataDialog.open();
      this.productTypeList = [];
      this.chooseDialogData = {};
      this.levelTableData = [];
      setTimeout(() => {
        this.dom = this.$refs.multipleTable.bodyWrapper;
        this.dom.addEventListener('scroll', () => {
          // 滚动距离
          let scrollTop = this.dom.scrollTop + 2;
          // 变量windowHeight是可视区的高度
          let windowHeight = this.dom.clientHeight || this.dom.clientHeight;
          // 变量scrollHeight是滚动条的总高度
          let scrollHeight = this.dom.scrollHeight || this.dom.scrollHeight;
          if (scrollTop + windowHeight > scrollHeight) {
            this.$nextTick(() => {
              if (this.levelTableData.length < this.scrollTotal) {
                this.scrollStart += 10;
                this.end += 10;
                this.searchDeviceLibrary();
              }
            })
          }
        })
      }, 2000)
    },
    onChooseSearch() {
      if (this.chooseDialogData.topProductTypeId == "" && this.chooseDialogData.productType == "" && this.chooseDialogData.searchKey == "") {
        this.$message.warning("请至少选择一个查询条件！");
      } else {
        let params = {
          start: 0,
          productTypeId: this.chooseDialogData.productType,
          searchKey: this.chooseDialogData.searchKey,
          end: 10,
          topProductTypeId: this.chooseDialogData.topProductTypeId,
          type: 1
        };
        EquipmentLibraryApi.searchDeviceLibrary(params).then(res => {
          if (res.data.code == 200) {
            this.levelTableData = res.data.data.dataList;
            this.scrollTotal = res.data.data.totalCount;
          }
        });
      }
    },
    handleSelectionChange(val) {
      let bindDeviceLibraryIds = [];
      for (let i in val) {
        var htmlDoc = this.parseHTML(val[i].deviceCode);
        bindDeviceLibraryIds.push({
          deviceId: val[i].deviceId,
          deviceCode: htmlDoc.textContent + "_" + (Number(new Date().getTime()) + Number(i))
        });
      }
      this.bindDeviceLibraryIds = bindDeviceLibraryIds;
    },
    parseHTML(html) {
      var t = document.createElement('template');
      t.innerHTML = html;
      return t.content.cloneNode(true);
    },
    handleSelectionRows(selection) {
      this.selectionRows = selection;
    },
    saveEquipmentLibraryChoose() {
      let params = {
        deviceLibraryCopyDTOList: this.bindDeviceLibraryIds,
        deviceLibraryId: this.chooseTreeId
      }
      EquipmentLibraryApi.batchBindDeviceLibrary(params).then(res => {
        if (res.data.code == 200) {
          this.$refs.chooseDataDialog.close();
          this.$message.success("操作成功！");
          this.onSearch();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg
          });
        }
      });
    },
    remove(node, data) {
      let self = this;
      this.$confirm('选项中可能存在子选项，删除后将连带子选项一起删除， 确定要执行此操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.deleteDeviceLibrary(node, data);
        })
        .catch(() => {});
    },
    deleteDeviceLibrary(node, data) {
      let params = {
        deviceId: this.currTreeData.id
      };
      EquipmentLibraryApi.deleteDeviceLibrary(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("删除成功！");
          // this.onSearch();
          const parent = node.parent;
          const children = parent.data.childList || parent.data;
          const index = children.findIndex(d => d.id === data.id);
          children.splice(index, 1);
          this.tableData = [];
        } else {
          this.$message({
            type: "error",
            message: res.data.msg
          });
        }
      });
    },
    edit() {
      this.isTreeEdit = true;
      this.isAddParentTree = false;
      this.$refs.levelConfigDialog.open();
      this.searchDeviceLibraryDetail();
    },
    searchDeviceLibraryDetail() {
      let params = {
        deviceId: this.currTreeData.id
      };
      EquipmentLibraryApi.searchDeviceLibraryDetail(params).then(res => {
        if (res.data.code == 200) {
          this.levelConfigForm = res.data.data;
          this.levelConfigForm.topProductTypeId = res.data.data.topProductId;
          this.levelConfigForm.manufacturersId = res.data.data.manufacturersId == 0 ? "" : res.data.data.manufacturersId;
          this.searchProductList(2);
        }
      });
    },
    copy(data) {
      this.$set(data, 'isCopyBlock', !data.isCopyBlock);
      this.copyDeviceCode = "";
      this.copyTreeData = data;
    },
    copyDeviceLibrary() {
      let params = {
        deviceId: this.copyTreeData.id,
        deviceCode: this.copyDeviceCode
      };
      EquipmentLibraryApi.copyDeviceLibrary(params).then(res => {
        if (res.data.code == 200) {
          this.$set(this.copyTreeData, 'isCopyBlock', false);
          this.$message.success("复制成功！");
          this.onSearch();
        }
      });
    },
    leadingIn() {
      this.leadingInForm = {};
      this.files = [];
      this.fileList = [];
      this.$refs.leadingInDialog.open();
    },
    beforeUpload(file) {
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
    },
    handleUpload(raw) {
      this.files.push(raw.file);
    },
    submitLeadingForm() {
      if (!this.leadingInForm.manufacturerId) {
        this.$message.warning('请选择厂商！');
        return false;
      }
      this.$refs.upload.submit();
      const formdata = new FormData();
      this.files.forEach(file => {
        formdata.append('files', file);
      });
      formdata.append('manufacturerId', this.leadingInForm.manufacturerId);
      let self = this;
      EquipmentLibraryApi.importDeviceLibrary(formdata)
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.data.error.length == 0) {
              self.$message.success('导入成功！');
            } else {
              let str = "";
              let arr = [];
              for (let i in res.data.data.error) {
                arr.push(res.data.data.error[i]);
              }
              str += arr.join("，");
              str += "导入失败！"
              self.$message.warning(str);
            }
            self.$refs.upload.clearFiles();
            self.onSearch();
          }
        }).catch((e) => {
        })
      this.$refs.leadingInDialog.close();
    },
    addDataPoint() {
      this.isTableEdit = false;
      this.dataPointConfigForm = {
        fieldName: '',
        dataTypeId: '',
        fieldCode: '',
        // defaultValue: '',
        // fieldDescribe: '',
        // coefficient: '',
        authorization: '',
        dataType: '',
        // type: '',
        valueType: '',
        // range: '',
        unit: '',
        count: '',
        isFixZero: false
      };
      this.$refs.dataPointConfigDialog.open();
      this.searchDataFieldTypes();
    },
    confirmDataPointConfigData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {};
          if (!this.isTableEdit) { //添加数据点
            this.dataPointConfigForm.deviceId = this.currTreeData.id;
            params = this.dataPointConfigForm;
            EquipmentLibraryApi.addDeviceDataField(params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("添加成功！");
                this.$refs.dataPointConfigDialog.close();
                this.searchFieldByDevice(this.currTreeData);
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg
                });
              }
            });
          } else { // 修改数据点
            params = {
              authorization: this.dataPointConfigForm.authorization,
              // coefficient: this.dataPointConfigForm.coefficient,
              dataTypeId: this.dataPointConfigForm.dataTypeId,
              // defaultValue: this.dataPointConfigForm.defaultValue,
              deviceId: this.dataPointConfigForm.deviceId,
              fieldCode: this.dataPointConfigForm.fieldCode,
              // fieldDescribe: this.dataPointConfigForm.fieldDescribe,
              id: this.dataPointConfigForm.id,
              fieldName: this.dataPointConfigForm.fieldName,
              dataType: this.dataPointConfigForm.dataType,
              // type: this.dataPointConfigForm.type,
              valueType: this.dataPointConfigForm.valueType,
              // range: this.dataPointConfigForm.range,
              unit: this.dataPointConfigForm.unit,
            };
            EquipmentLibraryApi.updateDeviceDataField(params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("修改成功！");
                this.$refs.dataPointConfigDialog.close();
                this.searchFieldByDevice(this.currTreeData);
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg
                });
              }
            });
          }
        } else {
          return false;
        }
      })
    },
    onEdit(row) {
      this.searchDataFieldTypes();
      for (let i in this.dataTypeIdList) {
        if (row.dataTypeId == this.dataTypeIdList[i].name) {
          row.dataTypeId = this.dataTypeIdList[i].id;
        }
      }
      this.isTableEdit = true;
      this.$refs.dataPointConfigDialog.open();
      this.dataPointConfigForm = JSON.parse(JSON.stringify(row));
    },
    onDelete(row) {
      let self = this;
      this.$confirm('确定要删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.deleteDeviceDataField(row.id);
        })
        .catch(() => {});
    },
    deleteDeviceDataField(id) {
      let params = {
        deviceDataFieldId: id
      };
      EquipmentLibraryApi.deleteDeviceDataField(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("修改成功！");
          this.searchFieldByDevice(this.currTreeData);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  width: 100%;
  height: 100%;
  padding-bottom: 10px;

  .leftTree {
    float: left;
    border-right: 1px solid;
    width: 350px;
    height: 72vh;
    padding-right: 10px;

    .filter-tree {
      height: 84%;
      margin-top: 20px;
      overflow: auto;
      padding-top: 10px;
    }

    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      overflow-x: auto;
      padding-right: 20px;

      &::-webkit-scrollbar {
        height: 5px;
      }
    }

    >>>.el-tree-node__content {
      height: 35px;
      line-height: 25px;
      padding-right: 5px;
    }
  }

  .batchBtn {
    position: absolute;
    right: 50px;
  }

  .rightTable {
    float: left;
    width: calc(100% - 350px);
    padding: 10px 0px 10px 20px;
    margin-top: 30px;
  }

  .btn {
    padding: 0px;
    font-size: 12px !important;

    &span {
      font-size: 12px !important;
    }
  }

  button.el-button.btn.el-button--text.el-button--mini {
    margin-left: 5px !important;
  }

  >>>.el-input-group__prepend {
    width: 100px;
    background: linear-gradient(135deg, #3897C1 0%, #1D7197 100%);
    color: #fff;
    font-family: PingFang;
    font-weight: 600;
  }

  >>>.el-input-group__append {
    width: 40px;
    background: linear-gradient(135deg, #0561E3 0%, #0049AD 100%);
    border-radius: 0px 4px 4px 0px;
    color: #fff;
  }

  >>>.el-input-group>.el-input__inner {
    border: 1px solid #E7E8EB;
    border: 1px 0px;
    border-radius: 0px !important;
  }

  .keywordClass {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .filterType {
    >>>.el-icon-arrow-up:before {
      color: #fff;
    }

    >>>.el-input__inner {
      background: #FFFFFF linear-gradient(135deg, #3897C1 0%, #1D7197 100%) !important;
      border: 0px !important;
      border-radius: 4px 0px 0px 4px !important;
      box-shadow: 0px 4px 17px 0px rgba(187, 187, 187, 0.5);
      color: #fff;
    }
  }

  .searchKeyClass {
    >>>.el-input__inner {
      border-radius: 0px 4px 4px 0px !important;
    }

    >>>.el-select .el-input__inner:focus,
    >>>.el-select .el-input.is-focus .el-input__inner {
      border-color: #f3f4f5;
    }
  }

  #sector {
    position: absolute;
  }

  #sector .moreIcon {
    margin-left: 5px;
  }

  #sector ul {
    width: 12px;
    position: relative;
    z-index: 99;
  }

  #sector ul li {
    list-style: none;
    position: absolute;
    background: #ccc;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    left: -18px;
    top: -42px;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-transform-origin: 100% 100%;
    -moz-transform-origin: 100% 100%;
    -ms-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }

  #sector .sector1 {
    margin-top: -25px;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector2 {
    margin-top: -15px;
    margin-left: 2px;
    // -webkit-transform: rotate(-30deg);
    // -moz-transform: rotate(-30deg);
    // -ms-transform: rotate(-30deg);
    // transform: rotate(-30deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector3 {
    margin-top: 0px;
    margin-left: -12px;
    // -webkit-transform: rotate(-60deg);
    // -moz-transform: rotate(-60deg);
    // -ms-transform: rotate(-60deg);
    // transform: rotate(-60deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector4 {
    margin-top: 20px;
    margin-left: -20px;
    // -webkit-transform: rotate(-90deg);
    // -moz-transform: rotate(-90deg);
    // -ms-transform: rotate(-90deg);
    // transform: rotate(-90deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector5 {
    margin-top: 40px;
    margin-left: -12px;
    // -webkit-transform: rotate(-120deg);
    // -moz-transform: rotate(-120deg);
    // -ms-transform: rotate(-120deg);
    // transform: rotate(-120deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector6 {
    margin-top: 56px;
    margin-left: 1px;
    // -webkit-transform: rotate(-150deg);
    // -moz-transform: rotate(-150deg);
    // -ms-transform: rotate(-150deg);
    // transform: rotate(-150deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector7 {
    margin-top: 66px;
    margin-left: 20px;
    // -webkit-transform: rotate(270deg);
    // -moz-transform: rotate(270deg);
    // -ms-transform: rotate(270deg);
    // transform: rotate(270deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector ul li p {
    position: absolute;
    top: 73px;
    left: 120px;
  }

  .copyBlock {
    background: #ccc;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    margin-left: -5%;
    margin-top: 50px;
    padding: 5px 10px;
    position: absolute;
    z-index: 99;
  }
}
</style><style lang="scss">
.el-select-dropdown.el-popper.filterTypePopper {
  background: #FFFFFF linear-gradient(135deg, #3897C1 0%, #1D7197 100%) !important;
  box-shadow: 0px 4px 17px 0px rgba(187, 187, 187, 0.5);
}

.filterTypePopper .el-select-dropdown__item {
  color: #fff;
}

.filterTypePopper .el-select-dropdown__item.selected {
  background: #fff;
  color: #2E81B1;
}

.filterTypePopper .el-select-dropdown__item.hover {
  background: #1D7197;
  color: #fff;
}

.filterTypePopper .popper__arrow {
  display: none !important;
}

button.el-button.moreBtn.el-button--text.el-button--small {
  color: #000;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  margin-left: 20px !important;
  margin-top: 10px !important;
}

button.el-button.moreBtn.el-button--text.el-button--small.is-disabled {
  color: #C0C4CC;
}

button.el-button.searchIcon.el-button--default.el-button--medium {
  background: linear-gradient(135deg, #0561E3 0%, #0049AD 100%);
  color: #fff;
}

.elSwitch .el-switch__label {
  font-weight: 600 !important;
}

.equipmentLibrary .el-tooltip {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/boss/equipmentLibrary/index.vue